/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, FormControl, Grid, Heading, HFlow, Icon, VFlow } from 'bold-ui'
import { useState } from 'react'

import { TipoGrupoParticipanteAtividadeColetivaEnum } from '../../../graphql/types.generated'
import {
  AtividadeColetivaGrupoItemModel,
  AtividadeColetivaGruposSelectField,
} from './AtividadeColetivaGrupoSelectField'

type AtividadeColetivaGruposFieldProps = {
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  onAdicionarGrupo(value: AtividadeColetivaGrupoItemModel): void
  onRemoverGrupo(value: AtividadeColetivaGrupoItemModel): void
}

export default function AtividadeColetivaGruposField(props: Readonly<AtividadeColetivaGruposFieldProps>) {
  const { tipoGrupo, onAdicionarGrupo, onRemoverGrupo } = props

  const [selectedValue, setSelectedValue] = useState<AtividadeColetivaGrupoItemModel | null>(null)
  const [grupoAdicionado, setGrupoAdicionado] = useState<boolean>(false)

  const handleSelectChange = (value: AtividadeColetivaGrupoItemModel | null) => {
    setSelectedValue(value)
  }

  const adicionarGrupo = () => {
    setGrupoAdicionado(true)
    onAdicionarGrupo(selectedValue)
  }

  const removerGrupo = () => {
    setGrupoAdicionado(false)
    onRemoverGrupo(selectedValue)
  }

  return (
    <Grid gap={1}>
      <Cell size={12}>
        <Heading level={2} style={styles.title}>
          Grupos
        </Heading>
        <VFlow vSpacing={1}>
          <HFlow>
            Selecione um grupo de atividade coletiva para importar automaticamente os participantes associados ao grupo
            para este registro. Alterações feitas na lista de participantes deste registro não impactarão a configuração
            original do grupo. Participantes adicionais também podem ser inseridos manualmente.
          </HFlow>
        </VFlow>
      </Cell>

      <Cell size={6}>
        <AtividadeColetivaGruposSelectField
          name='grupos'
          label='Grupos de atividade coletiva'
          tipoGrupo={tipoGrupo}
          disabled={grupoAdicionado}
          onChange={handleSelectChange}
        />
      </Cell>

      <Cell size={3}>
        <FormControl label={<span>&nbsp;</span>}>
          {grupoAdicionado ? (
            <Button kind='danger' skin='outline' size='small' onClick={removerGrupo}>
              <HFlow hSpacing={0.5}>
                <Icon icon='timesDefault' />
                Remover grupo
              </HFlow>
            </Button>
          ) : (
            <Button
              kind='primary'
              skin='outline'
              size='small'
              disabled={selectedValue === null}
              onClick={adicionarGrupo}
            >
              Adicionar grupo
            </Button>
          )}
        </FormControl>
      </Cell>
    </Grid>
  )
}

const styles = {
  title: css`
    margin-bottom: 0.5rem;
  `,
}
